import type { MediaTimelineBarLabels, VideoPlaybackBarLabels } from "@carbon6/c6-frontend-design";

export const PLAYBACK_LABELS: Partial<VideoPlaybackBarLabels> = {
  play: "재생",
  pause: "일시정지",
  stop: "정지",
  toStart: "처음으로",
  stepBackward: "한 프레임 뒤로",
  stepForward: "한 프레임 앞으로",
  toEnd: "끝으로",
  seek: "재생 위치",
  playbackRate: "재생 속도",
  buffering: "영상을 준비하는 중",
  waiting: "영상을 기다리는 중",
};

/** c6 타임라인 바의 접근 이름 · 툴팁(기본이 영어라 한국어로 덮는다). */
export const TIMELINE_LABELS: Partial<MediaTimelineBarLabels> = {
  play: "재생",
  pause: "일시정지",
  stop: "정지",
  toStart: "처음으로",
  stepBackward: "한 프레임 뒤로",
  stepForward: "한 프레임 앞으로",
  toEnd: "끝으로",
  seek: "재생 위치",
  timelineZoom: "타임라인 확대",
  zoomOut: "타임라인 축소",
  resetZoom: "타임라인 확대 초기화",
  zoomIn: "타임라인 확대",
  playbackRate: "재생 속도",
  previousTimelineSegment: "이전 구간 보기",
  nextTimelineSegment: "다음 구간 보기",
  buffering: "영상을 준비하는 중",
  waiting: "영상을 기다리는 중",
};
